import { useTranslation } from 'react-i18next';
import { TableCell } from '@mui/material';
import { cardTypeLabels } from '@utils/static';

export default function CardTypeCell({ row }) {
  const { t } = useTranslation();
  return (
    <TableCell>
      <p className="text-capitalize">{t(cardTypeLabels[row.type])}</p>
    </TableCell>
  );
}
